<script setup lang="ts">

    const props = defineProps<{
        image: string;
        text: string;
        href: string;
    }>();

    function itemClick() {
        window.open(props.href, '_blank');
    }
</script>

<template>
    <div
        class="link-box mb-3"
        tabindex="0"
        @click="itemClick()"
        @keydown.enter="itemClick()">
        <img
            :src="image"
            class="m-4"
            width="32"
            height="32">
        <div class="link-box-spacer">
            <div>
                {{ text }}
            </div>
            <b-icon
                icon="open-in-new"
                class="m-4" />
        </div>
    </div>
</template>

<style scoped>
.link-box {
    display: flex;
    align-items: center;
    background-color: var(--eq-white);
    width: 70%;
    height: 5rem;
    cursor: pointer;
}
.link-box:hover {
    font-weight: bold;
}
.link-box-spacer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;
}
</style>
